export const list = {
  input: {
    list_id: {
      label: 'List'
    }
  },

  state: {
    init: {
      description: `
            Lists of numbers - an element of the scheme that allows you to filter incoming calls by number.
            Depending on whether the number is on the list or not, it will go on a different branch of the routing scheme.
            You can add a new list of numbers in your account in the`
    }
  }
};
